require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./tapd-in-ecommerce-product-pages-that-convert.json") })
        }
      }, "path---tapd-in-ecommerce-product-pages-that-convert");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---tapd-in-ecommerce-product-pages-that-convert!./.cache/json/tapd-in-ecommerce-product-pages-that-convert.json
// module id = 828
// module chunks = 231608221292675